export const styles = () => ({
  closeButton: {
    position: 'absolute',
    top: 0,
    right: 0,
    zIndex: '1',
  },
  spacedButton: {
    top: 12,
    right: 12,
  },
  title: {
    maxHeight: 76,
    alignItems: 'center',
    flex: '0 0 auto',
    zIndex: '0',
    padding: '20px 0px 0px 20px',
  },
});
